const activityStatuses = {
  id: "activityStatuses",
  label: "Activity Statuses",
  endpoint: "activity_statuses",
  columnConfig: [
    {
      field: "name",
      headerName: "Activity Status",
      width: 250,
      description: "Activity Status",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default activityStatuses;
